import { useQuery } from '@tanstack/react-query'
import { getHealth } from '@/lib/api/health'

/**
 * System Health status (Screen 7). staleTime 0 so every visit / [Refresh]
 * re-runs the checks — a stale "all green" is worse than a brief spinner here.
 */
export function useHealth() {
  return useQuery({
    queryKey: ['health'],
    queryFn: getHealth,
    staleTime: 0,
    refetchOnWindowFocus: true,
  })
}
